import React from "react";
import Card from "../../../../componets/Card";
import { SkinInterface } from "../../../../store/mods_factory/skinsSlice";

const _Details = ({ skin }: { skin: SkinInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {skin?.search_text}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body Content</h4>
        {skin?.body}
      </Card>
    </>
  );
}

export default _Details;
